import React from 'react';
import { useSelector, useDispatch } from "react-redux";

import { incrementLoginStep, decrementLoginStep, setSignUp, setLogin } from "../../../../Features/Misc/loginSlice"

import MediaFooter from "../../../Components/MediaFooter";
import Footer from "../../../Components/Footer";


export default function SubMem() {

    //redux methods
    const dispatch = useDispatch();

    const takeMeToSignup = () => {
        dispatch(incrementLoginStep())
        dispatch(setSignUp())
    }

    const takeMeToLogin = () => {
        dispatch(incrementLoginStep())
        dispatch(setLogin())
    }

    //redux state
    const {  loginStep } = useSelector((state) => state.login)


    // const WelcomeLeftColumnisation = " col-start-1 col-end-13  text-center "
    const welcomeStatus = (loginStep === 1 ? " hidden " : " grid " )

    return (




        <div className={`submem-inner ${welcomeStatus} h-screen SignupLeft col-start-1 col-end-13 row-start-1 row-end-13 grid-cols-12 grid-rows-12 `} style={{backgroundImage: `url("https://www.kipmate.com/sortyourkip/client/build/Group_4580.png")`}}>
            <img className="w-32 mx-auto row-start-2 row-end-3 col-start-2 col-end-12" src="https://www.kipmate.com/sortyourkip/client/build/kmlogo.svg" alt=""/>
            <div className={`SignupLeft__superTitle row-start-3 row-end-4 text-lg font-semibold col-start-2 col-end-12  text-center  `}>
                A toolbox that improves your sleep health
            </div>

            <div className={`SignupLeft__corporateTitle row-start-4 row-end-5 text-lg font-bold col-start-3 col-end-11  flex items-center justify-center  }`}>
                Corporate Account
            </div>
            <div className={`SignupLeft__corporateText row-start-5 row-end-6 col-start-2 col-end-12 text-center  }`}>
                Direct Debit paid yearly, with the price based on the number of accounts.
            </div>
            <div className={`SignupLeft__individualTitle row-start-6 row-end-7 text-lg font-bold  col-start-3 col-end-11 flex items-center justify-center  }`}>
                Individual Account
            </div>
            <div className={`SignupLeft__individualText row-start-7 row-end-9 col-start-2 col-end-12 bg text-center `}>
                As an individual user pay 1, 3, or 12 months upfront, securely through Stripe.
            </div>

            <div className={`SignupLeft__pagination flex px-2 row-start-8 row-end-9 col-start-6 col-end-8 items-center text-2xl justify-between`}>
                <div className=" flex flex-row progressBar h-1 rounded-lg gap-2  w-20 ">
                    <div className="h1 bg-pink-dashboard rounded-lg w-6"></div>
                    <div className="h1    bg-pink-icon rounded-lg w-12"></div>
                </div>
            </div>

            <div className={`SignupLeft__buttonRow row-start-9 row-end-10 col-start-1 col-end-13 grid grid-cols-23 grid-rows-1 `}>
                <div onClick={() => takeMeToSignup() } className="SignupLeft__buttonRow__signUp border-3 border-gold-accent col-start-5 col-end-12 flex items-center justify-center h-12 rounded-lg  cursor-pointer">Sign Up</div>
                <div onClick={() => takeMeToLogin() } className="SignupLeft__buttonRow__logIn bg-gold-accent col-start-13 col-end-20 flex items-center justify-center h-12 rounded-lg  cursor-pointer">Log In</div>
            </div>

            <MediaFooter className={`col-start-1 col-end-13 row-start-11 row-end-12 flex items-center justify-center mx-auto`} />
            <Footer className={` submem-footer flex col-start-1 col-end-13 row-start-12 text-xs row-end-13 text-pink-icon  items-center justify-start mx-auto`}/>

        </div>




    );
}
